import {action, computed, observable} from "mobx";
import {WpexApi} from "../api/WpexApi";
import {jssPreset} from "@material-ui/styles";
import rtl from "jss-rtl";
import {create} from 'jss';
import {createMuiTheme} from "@material-ui/core";
import i18next from 'i18next';

class UiStore {

    api: WpexApi;
    _jssLTR: any = create({plugins: [...jssPreset().plugins]});
    _jssRTL: any = create({plugins: [...jssPreset().plugins, rtl()]});

    _themeRTL: any = createMuiTheme({
        direction: 'rtl',
        palette: {
            primary: {
                main: '#3ea9f5',
                contrastText: 'white',
            },
        },
    });

    _themeLTR: any = createMuiTheme({
        palette: {
            primary: {
                main: '#3ea9f5',
                contrastText: 'white',
            },
        },
    });

    @observable locale: string = '';

    @observable stepperState = 1; // 1-4

    @observable campaignDraftOrNew: 'Draft' | 'New' = 'New';

    constructor(api: WpexApi) {
        this.api = api;
        this.setLocale();
    }

    @action setLocale = async () => {
        const response = await this.api.getLocale();
        await i18next.changeLanguage(response.locale);
        this.locale = response.locale;
    };

    @computed get dir() {
        return this.isRTL ? 'rtl' : 'ltr';
    }

    @computed get isRTL() {
        return (this.locale === 'he_IL');
    }

    @computed get textAlign() {
        return this.isRTL ? 'right' : 'left';
    }

    @computed get jss() {
        return this.isRTL ? this._jssRTL : this._jssLTR;
    }

    @computed get theme() {
        return this.isRTL ? this._themeRTL : this._themeLTR;
    }

    @action setStep = (step: number) => {
        this.stepperState = step;
    }

    @computed get isDraftCampaign() {
        return this.campaignDraftOrNew === 'Draft';
    }
}

export default UiStore;
